/**
 * Configuração única de acesso à API do Delivery.
 * Sem REACT_APP_BACKEND_URL, usa o backend de produção (Cloud Run).
 */
export const BACKEND_URL = (
  process.env.REACT_APP_BACKEND_URL ||
  "https://delivery-bonfimgourmet-244425130782.southamerica-east1.run.app"
).replace(/\/+$/, "");

/** Endpoint STOMP (WebSocket nativo, sem SockJS) */
export const WS_URL = `${BACKEND_URL.replace(/^http/i, "ws")}/ws`;
